import { Link } from 'react-router-dom';
import classes from './Poster.module.css';
import SS from './../../Assest/df.png';
import { FaHouseDamage, FaAddressCard, FaList, FaAddressBook, FaInstagram, FaFacebook, FaLinkedin, FaYoutube, FaWhatsapp,FaCheckSquare  } from "react-icons/fa";

const Poster=()=>{
    return(
    <div className={classes.herobg}>

<div className={classes.a1}>


     <h1 className={classes.p3}>Guiding You To</h1>
     <h1 className={classes.p2}>Your MBBS Dream</h1>


     <section className={classes.neetSection}>
      <div className={classes.neetCard}>
        <h2 className={classes.neetTitle}>
          Complete NEET Admission Counselling
        </h2>

        <ul className={classes.neetList}>
          <li className={classes.neetItem}>
            <FaCheckSquare className={classes.neetIcon} />
            Trusted NEET Counsellors
          </li>
          <li className={classes.neetItem}>
            <FaCheckSquare className={classes.neetIcon} />
            Expert Medical Admission Guidance
          </li>
          <li className={classes.neetItem}>
            <FaCheckSquare className={classes.neetIcon} />
            College Selection & Preference List
          </li>
          <li className={classes.neetItem}>
            <FaCheckSquare className={classes.neetIcon} />
            Cutoff Updates & Seat Matrix
          </li>
          <li className={classes.neetItem}>
            <FaCheckSquare className={classes.neetIcon} />
            Personalised Counselling
          </li>
        </ul>
      </div>
    </section>

     <h2 className={classes.neetTitle1}>
          Get Free 1-1 Counselling
        </h2>

        <h6 className={classes.neetItems}>
            Pune | PCMC | Mumbai | Nagpur | Nashik
        </h6>
    
</div>


<div className={classes.a2}>

<img src={SS} className={classes.a21}></img>
    
</div>
    </div>
    );
};


export default Poster;



/*


     {<h1 className={classes.p2}>RUSHIKESH CAREER GUIDENCE</h1>
     <p className={classes.p3}>TURNING CAREER CONFUSION TO CLARITY</p><br/>
      <p className={classes.p3}>COUNCELLING ALL OVER INDIA</p>

     <div className='bfd'>
     <button className={classes.btn}><Link to='/Contact' className={classes.btnlink}>MEDICAL</Link></button>
     <button className={classes.btn}><Link to='/Contact' className={classes.btnlink}>ENGINEERING</Link></button>
       </div>}

       */